/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HalJson } from '../../models/hal-json';
import { MenuDaypartResult } from '../../models/menu-daypart-result';

export interface MenusMenuIdDaypartsGet$Params {
  'Active-Tenant-Identifier': string;
  menuId: string;
}

export function menusMenuIdDaypartsGet(http: HttpClient, rootUrl: string, params: MenusMenuIdDaypartsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
'_embedded'?: {
'dayparts'?: Array<MenuDaypartResult>;
};
}>> {
  const rb = new RequestBuilder(rootUrl, menusMenuIdDaypartsGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('menuId', params.menuId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      '_links'?: HalJson;
      '_embedded'?: {
      'dayparts'?: Array<MenuDaypartResult>;
      };
      }>;
    })
  );
}

menusMenuIdDaypartsGet.PATH = '/menus/{menuId}/dayparts';
